export default __webpack_public_path__ + "static/media/I bet I can make you laugh.03a6d00b.mp4";